import React from "react";

const PDFControls = ({
  numPages,
  currentPage,
  setCurrentPage,
  scale,
  setScale,
}) => {
  return (
    <div className="ps-toolbar">
      {numPages && (
        <div className="ps-toolbar-controls">
          <button
            className="ps-left-right-btn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage <= 1}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m15 18-6-6 6-6" />
            </svg>
          </button>
          <span>
            Page {currentPage} of {numPages}
          </span>
          <button
            className="ps-left-right-btn"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, numPages))
            }
            disabled={currentPage >= numPages}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m9 18 6-6-6-6" />
            </svg>
          </button>
        </div>
      )}

      <div className="ps-toolbar-controls ps-toolbar-zoom">
        <button
          className="ps-toolbar-btn"
          onClick={() => setScale((prev) => Math.max(prev - 0.25, 1))}
        >
          -
        </button>
        <span>{Math.round(scale * 100)}%</span>
        <button
          className="ps-toolbar-btn"
          onClick={() => setScale((prev) => Math.min(prev + 0.25, 2))}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default PDFControls;
